import { render, staticRenderFns } from "./QuickStats.vue?vue&type=template&id=c42adb68&scoped=true&"
import script from "./QuickStats.vue?vue&type=script&lang=js&"
export * from "./QuickStats.vue?vue&type=script&lang=js&"
import style0 from "./QuickStats.vue?vue&type=style&index=0&id=c42adb68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42adb68",
  null
  
)

export default component.exports